import React, { useState, useEffect, useRef } from "react";
import { motion, AnimatePresence, useInView } from "framer-motion";
import "./Showcase.css";

const images = [
  "BridgeRed.jpg",
  "BridgeGreen.jpg",
  "AddEmployee.jpg",
  "AdminList.jpg",
];

const Showcase = () => {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [isHovered, setIsHovered] = useState(false);
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, amount: 0.3 });

  useEffect(() => {
    if (!isHovered) {
      const timer = setInterval(() => {
        setCurrentImageIndex((prevIndex) =>
          prevIndex === images.length - 1 ? 0 : prevIndex + 1
        );
      }, 4000);

      return () => clearInterval(timer);
    }
  }, [isHovered]);

  return (
    <section className="showcase">
      <div className="carousel-container">
        <motion.div
          className="carousel"
          onHoverStart={() => setIsHovered(true)}
          onHoverEnd={() => setIsHovered(false)}
        >
          <AnimatePresence mode="wait">
            <motion.img
              key={currentImageIndex}
              src={require(`../components/Imgs/${images[currentImageIndex]}`)}
              initial={{ opacity: 0, scale: 0.95 }}
              animate={{ opacity: 1, scale: 1 }}
              exit={{ opacity: 0, scale: 0.95 }}
              transition={{ duration: 0.5 }}
            />
          </AnimatePresence>
          <div className="dots">
            {images.map((_, index) => (
              <motion.div
                key={index}
                className={`dot ${index === currentImageIndex ? "active" : ""}`}
                onClick={() => setCurrentImageIndex(index)}
                whileHover={{ scale: 1.2 }}
              />
            ))}
          </div>
        </motion.div>
      </div>
      <div className="showcase-text" ref={ref}>
        <motion.div
          initial={{ opacity: 0, x: 100 }}
          animate={isInView ? { opacity: 1, x: 0 } : { opacity: 0, x: 100 }}
          transition={{ duration: 1, delay: 0.2 }}
        >
          <h2>See MusterTaker in Action</h2>
          <div className="feature-bullets">
            <motion.ul
              initial={{ opacity: 0, x: 100 }}
              animate={isInView ? { opacity: 1, x: 0 } : { opacity: 0, x: 100 }}
              transition={{ duration: 1, delay: 0.5 }}
            >
              <li>
                <div className="feature-item">
                  <span>Lifeboat Facial Recognition Speed</span>
                  <p>
                    Onboard lifeboats are equipped with cameras for SoTA facial
                    recognition within 0.5 seconds.
                  </p>
                </div>
              </li>
              <li>
                <div className="feature-item">
                  <span>Bridge Dashboard</span>
                  <p>
                    Keep the captain informed with a real-time overview of
                    mustering status with lifeboat occupancy percentages
                    displayed.
                  </p>
                </div>
              </li>
              <li>
                <div className="feature-item">
                  <span>Admin Portal</span>
                  <p>
                    The Admin portal allows authorized users to add, edit, or
                    remove employee profiles, and supports bulk CSV uploads for
                    streamlined setup.
                  </p>
                </div>
              </li>
              <li>
                <div className="feature-item">
                  <span>Add Employee Page</span>
                  <p>
                    Easily capture essential employee details, including their
                    emergency contacts and lifeboat assignments, ensuring quick
                    access to key information during a muster.
                  </p>
                </div>
              </li>
            </motion.ul>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default Showcase;
